import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-dialog-success',
  templateUrl: './dialog-success.component.html',
  styleUrls: ['./dialog-success.component.scss']
})
export class DialogSuccessComponent implements OnInit {

  constructor(
        public dialogRef: MatDialogRef<DialogSuccessComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
      ) { 
        dialogRef.disableClose = false;
      }
    
      ngOnInit() {
      }
    
      onNoClick() {
        this.dialogRef.close();
      }

}

// import { Component, OnInit, Inject } from '@angular/core';
// import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

// @Component({
//   selector: 'app-dialog-fail',
//   templateUrl: './dialog-fail.component.html',
//   styleUrls: ['./dialog-fail.component.scss']
// })
// export class DialogFailComponent implements OnInit {

//   constructor(
//     public dialogRef: MatDialogRef<DialogFailComponent>,
//     @Inject(MAT_DIALOG_DATA) public message: string
//   ) { 
//     dialogRef.disableClose = false;
//   }

//   ngOnInit() {
//   }

//   onNoClick() {
//     this.dialogRef.close();
//   }

// }
